export default __webpack_public_path__ + "52bb9729d52c5b34394a9441bebc24a0.png";